import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Router, RouterModule } from '@angular/router';
import { SessionService } from '@ildes/services/session.service';
import { SessionStore } from '@ildes/stores/session.store';

@Component({
  selector: 'app-back-office',
  standalone: true,
  imports: [
    MatToolbarModule,
    MatIconModule,
    RouterModule,
    MatButtonModule
  ],
  template: `<mat-toolbar>
      <div class="mat-toolbar-content">
        <div class="column-full-space">
          <img src="./assets/images/logo.png" class="logo">
        </div>
        <button (click)="exit()" mat-button matIconButtonaria-label="Example icon-button with a menu">
          <mat-icon>exit_to_app</mat-icon>
        </button>
      </div>
    </mat-toolbar>
    <div class="scrolling">
        <div class="container center">
            <router-outlet></router-outlet>
        </div>
    </div>
    `,
  styleUrls: ['./back-office.component.css']
})
export class BackOfficeComponent implements OnInit {

    user;

    constructor(
        private router: Router,
        private sessionService: SessionService,
    ) {
        
    }

    ngOnInit(): void {
        this.user = SessionStore.getInstance().get()?.user;

        if (!this.user?.admin) {
            this.router.navigate(['back-office/signin']);
        
            return;
        }
        
    }

    exit() {
        this.sessionService.invalidate();
        this.router.navigate(['back-office/signin']);
    }
}
